import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { synchronizeTasks } from "../../../actions/planer";
import PlanerTitle from "./PlanerTitle";
import PlanerComposer from "./PlanerComposer";
import PlanerListView from "./PlanerListView";

/**
 * Imports the planer stylesheet.
 */
import "./Planer.css";

/**
 * AgendaPlaner : Component
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Planer component which displays a list of tasks from a Redux
 * store and allows the user to compose new tasks.
 */
class AgendaPlaner extends Component {
  state = {};
  /**
   * Synchronizes tasks on mount from server.
   */
  componentDidMount = () => {
    this.props.synchronizeTasks();
  };
  render() {
    return (
      <div className="ag-planer">
        <PlanerTitle />
        <PlanerComposer onCreate={this.onCreateTask} />
        <PlanerListView items={this.state.items} />
      </div>
    );
  }
}

AgendaPlaner.propTypes = {
  /**
   * synchronizeTasks: () => ()
   * Synchronization action of the API which should be
   * dispatched upon mount
   */
  synchronizeTasks: PropTypes.func.isRequired
};

export default connect(
  null,
  { synchronizeTasks }
)(AgendaPlaner);



// WEBPACK FOOTER //
// ./src/modules/agenda/planer/AgendaPlaner.js